/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import peerviewLogoCircle from '../../assets/images/peerview-data-logo-white-small.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faDiagramProject, faGear, faCaretDown, faMagnifyingGlass, faMap, faCircleArrowRight, faCircleArrowLeft, faBook, faChartPie, faFileLines, faIndustry, faShield, faUser, faHospital } from "@fortawesome/free-solid-svg-icons";
import VideoModal from "./VideoModal";
import Modal from 'react-modal';
import NewUserForm from './NewUserForm';
import workflows from "./workflows/workflow_data";

const TopNavbar = (props) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState('');
    const [displayUserMenu, setDisplayUserMenu] = useState(false)
    const [searchResults, setSearchResults] = useState(
        {
            display: false,
            isLoading: false,
            results: [],
            admin_results: []
        }
    )
    const [addNew, setAddNew] = useState(false)
    const [activePopover, setActivePopover] = useState(null);
    const [analysisReportViewPopover, setAnalysisReportViewPopover] = useState(null);
    const [moneyReportViewPopover, setMoneyReportViewPopover] = useState(null);
    const [expandNavbar, setExpandNavbar] = useState(false)
    const [modalReport, setModalReport] = useState("money");
    const [videoModalOpen, setVideoModalOpen] = useState(false);
    const [newUserModalOpen, setNewUserModalOpen] = useState(false);
    const [newUserFormData, setNewUserFormData] = useState({
        all_companies: [],
        email_ends: [],
        filter_options_obj: {},
    })
    const modalRef = useRef(null);
    const buttonRef = useRef(null);

    const workFlowSections = [
        {
            title: "Growth",
            linkIds: [14]
        },
        {
            title: "Profitability",
            linkIds: [2, 5, 8, 9, 10, 11, 13]
        },
        {
            title: "Liquidity",
            linkIds: [4, 7]
        },
        {
            title: "Leverage",
            linkIds: [8, 12]
        },
        {
            title: "Cash Flow",
            linkIds: [1, 4, 8]
        },
        {
            title: "Activity",
            linkIds: [3, 4, 6]
        },
    ]


    const openVideoModal = (reportVal) => {
        setModalReport(reportVal)
        setVideoModalOpen(true);
    }

    const closeVideoModal = () => {
        setVideoModalOpen(false);
    }

    const hrefBuilder = (subdomain, path) => {
        const domainSplit = document.location.host.split('.');
        domainSplit[0] = subdomain;
        return location.protocol + '//' + domainSplit.join('.') + path;
    };

    const toggleNavbar = () => {
        setExpandNavbar(!expandNavbar);
        setAddNew(false)
    };

    const handleMouseEnter = (item, type = null) => {
        if (item !== 'reports') {
            setAnalysisReportViewPopover(null);
            setMoneyReportViewPopover(null)
        }
        setActivePopover(item);
        setAddNew(false)
    };

    const handleMouseLeave = (item, type = null) => {
        if (item === 'leave' && type === 'reports' && !analysisReportViewPopover && !moneyReportViewPopover) {
            setActivePopover(null);
        } else if (item === 'leave' && !type) {
            setActivePopover(null);
        }
    };

    const handleAnalysisReportMouseEnter = (item) => {
        setAnalysisReportViewPopover(item);
    };

    const handleMoneyReportMouseEnter = (item) => {
        setMoneyReportViewPopover(item);
    };

    const handleReportMouseLeave = (item) => {
        if (item === 'leave') {
            setAnalysisReportViewPopover(null);
            setMoneyReportViewPopover(null)
        }
    };

    useEffect(() => {
        // Define the click handler
        const handleClickAnywhere = (event) => {

            if (
                modalRef.current &&
                !modalRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setDisplayUserMenu(false);
            }
        };

        // Add event listener to document
        document.addEventListener('click', handleClickAnywhere);

        // Clean up the event listener on component unmount
        return () => {
            document.removeEventListener('click', handleClickAnywhere);
        };
    }, []);


    useEffect(() => {
        // Set up the debouncer with a delay (e.g., 500ms)
        const handler = setTimeout(() => {
            setDebouncedQuery(searchQuery);
        }, 1000); // Adjust the delay as needed

        // Clear the timeout if searchQuery changes (user is still typing)
        return () => {
            clearTimeout(handler);
        };
    }, [searchQuery]); // Run the effect when searchQuery changes

    useEffect(() => {
        // Define the async function to perform the search
        const fetchSearchData = async () => {
            if (debouncedQuery) {
                setSearchResults(prevState => {
                    return {
                        ...prevState,
                        isLoading: true,
                    }
                })

                try {
                    const response = await fetch(`/api/v1/company_search/?term=${debouncedQuery}`);

                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const data = await response.json();

                    setSearchResults(prevState => {
                        return {
                            ...prevState,
                            isLoading: false,
                            results: data.firm_results,
                            admin_results: data.admin_results
                        }
                    })
                    // Handle the results (e.g., update state with the results)
                } catch (error) {
                    console.error('There was a problem', error);
                }
            }
        };

        // Call the async function
        fetchSearchData();
    }, [debouncedQuery]); // Run the effect when debouncedQuery changes

    const handleNewUserFormData = async () => {
        try {
            const response = await fetch(`/user_permissions_info`);

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            setNewUserFormData(data)
            setNewUserModalOpen(true)
            // Handle the results (e.g., update state with the results)
        } catch (error) {
            console.error('There was a problem', error);
        }
    }

    const openSearchResults = () => {
        setSearchResults(prevState => {
            return {
                ...prevState,
                display: true
            }
        })
        setAddNew(false)
    }

    const closeSearchResults = () => {
        setSearchResults(prevState => {
            return {
                ...prevState,
                display: false,
                isLoading: false
            }
        })
    }

    const handleInputChange = (e) => {
        setSearchQuery(e.target.value);
    }

    const buildReportViewLinks = (reportViews, page = 'reporting') => {
        let reportTypes = Object.keys(reportViews);
        let allReportViews = [];
        reportTypes.forEach(type => {
            let setOfReportViews = reportViews[type].map(rv => {
                return {
                    id: rv.id,
                    archived: rv.archived,
                    name: rv.name,
                    link: hrefBuilder(props.child_subdomain, `/reports/${page}/${rv.id}`)
                }
            })
            allReportViews = [...allReportViews, ...setOfReportViews]
        })
        return allReportViews;
    }

    // let newUserLink = hrefBuilder(props.parent_subdomain, '/clients/new')
    // Check for different Users
    let newCompanyLink = hrefBuilder(props.parent_subdomain, '/admin/companies/new')

    let userDashboardLink = props.isAdminView ? hrefBuilder('app', '') : hrefBuilder(props.parent_subdomain, '/dashboard')
    let manageFirmLink = hrefBuilder(props.parent_subdomain, '/manage_firm')
    let notificationLink = hrefBuilder(props.parent_subdomain, '/notifications')
    let profileLink = hrefBuilder(props.parent_subdomain, '/users/edit')
    let exportsLink = hrefBuilder(props.child_subdomain, '/exports')
    let manageSubscriptionsLink = hrefBuilder(props.parent_subdomain, '/subscriptions')
    let controlPanelLink = hrefBuilder(props.parent_subdomain, '/admin/control_panel')
    let signOutLink = hrefBuilder('app', '/users/sign_out')

    let analysisLink = hrefBuilder(props.child_subdomain, '/reports/analysis')
    let reportingLink = hrefBuilder(props.child_subdomain, '/reports/reporting')
    let reportViewLinksAdminAnalysis = props.report_views?.admin_analysis ? buildReportViewLinks(props.report_views.admin_analysis, 'analysis') : []
    let reportViewLinksNormalAnalysis = props.report_views?.normal_analysis ? buildReportViewLinks(props.report_views.normal_analysis, 'analysis') : []
    let reportViewLinksAdminMoney = props.report_views?.admin_money ? buildReportViewLinks(props.report_views.admin_money, 'reporting') : []
    let reportViewLinksNormalMoney = props.report_views?.normal_money ? buildReportViewLinks(props.report_views.normal_money, 'reporting') : []
    let mappingLink = hrefBuilder(props.child_subdomain, '/mapping_approvals/new')
    let iowaLink = null
    let manhatLink = null
    let minnesotaLink = null
    if (props.parent_subdomain === 'cainellsworth') {
        iowaLink = hrefBuilder(props.child_subdomain, '/ce_reports/iowa')
        manhatLink = hrefBuilder(props.child_subdomain, '/ce_reports/manhattan')
        minnesotaLink = hrefBuilder(props.child_subdomain, '/ce_reports/minnesota')
    }

    let superAdminLink = hrefBuilder('app', '')
    let superCompaniesLink = hrefBuilder('app', '/admin/companies')
    let superParentCompaniesLink = hrefBuilder('app', '/admin/parent_companies')
    let superNaicsLink = hrefBuilder('app', '/admin/naicses')
    let superOpsLink = hrefBuilder('app', '/admin/ops')
    let superDashBoardEditorLink = hrefBuilder('app', '/admin/dashboard_views')

    let parentAdminLink = hrefBuilder(props.parent_subdomain, '/clients')
    let childAdminLink = hrefBuilder(props.child_subdomain, '/clients')

    let manageClientsLink = hrefBuilder(props.parent_subdomain, '/companies')
    let resourcesLink = 'https://www.peerviewdata.com/resources-page'
    let nschbcLink = hrefBuilder(props.parent_subdomain, '/nschbc_reports')
    let firmLink = hrefBuilder(props.parent_subdomain, '/group_reports/firm')
    let practiceLink = hrefBuilder(props.parent_subdomain, '/group_reports/practice')
    let industryLink = hrefBuilder(props.parent_subdomain, `/reports/industry/${props.company_id}`)

    const reportLinkBuilder = (currentReport, planAccess, icon = true) => {
        let reportName = currentReport === 'Audit' ? 'Audit (Beta)' : currentReport
        let reportNameLowerCase = currentReport.toLowerCase().replace(/\s/g, "")
        let reportLink = currentReport === 'Planning' ? `/reports/monthly/${reportNameLowerCase}` : `/reports/${reportNameLowerCase}`

        if (currentReport === 'Firm') {
            let innerText = icon ? 'Firm' : 'Firm Report';
            if (props.user_type === 'Admin' || planAccess) {
                return (
                    <a href={firmLink}>
                        {icon && <FontAwesomeIcon icon={faChartPie} className='menu-icon' />}
                        <span className={icon ? 'left-menu-text' : ''}>{innerText}</span>
                    </a>
                )
            } else {
                return (
                    <a onClick={() => openVideoModal(reportNameLowerCase, planAccess)}>
                        {icon && <FontAwesomeIcon icon={faChartPie} className='menu-icon' />}
                        <span className={icon ? 'left-menu-text' : ''}>{innerText}</span>
                    </a>
                )
            }
        }

        if (currentReport === 'Practice') {
            let innerText = icon ? 'Practice' : 'Practice Report';
            if (props.user_type === 'Admin' || planAccess) {
                return (
                    <a href={practiceLink}>
                        {icon && <FontAwesomeIcon icon={faMagnifyingGlass} className='menu-icon' />}
                        <span className={icon ? 'left-menu-text' : ''}>{innerText}</span>
                    </a>
                )
            } else {
                return (
                    <a onClick={() => openVideoModal(reportNameLowerCase, planAccess)}>
                        {icon && <FontAwesomeIcon icon={faMagnifyingGlass} className='menu-icon' />}
                        <span className={icon ? 'left-menu-text' : ''}>{innerText}</span>
                    </a>
                )
            }
        }

        if (currentReport === 'Industry') {
            let innerText = icon ? 'Industry' : 'Industry Report';
            if (props.user_type === 'Admin' || planAccess) {
                return (
                    <a href={industryLink}>
                        {icon && <FontAwesomeIcon icon={faIndustry} className='menu-icon' />}
                        <span className={icon ? 'left-menu-text' : ''}>{innerText}</span>
                    </a>
                )
            } else {
                return (
                    <a onClick={() => openVideoModal(reportNameLowerCase, planAccess)}>
                        {icon && <FontAwesomeIcon icon={faIndustry} className='menu-icon' />}
                        <span className={icon ? 'left-menu-text' : ''}>{innerText}</span>
                    </a>
                )
            }
        }

        // Freemium can only access Money report and can't use report credits
        if (props.user_type !== 'Admin' && !planAccess || (props.user_type !== 'Admin' && planAccess && !props.reports_unlocked)) {
            return (
                <a onClick={() => openVideoModal(reportNameLowerCase, planAccess)} onMouseEnter={() => handleReportMouseLeave('leave')}>{reportName}</a>
            )
        }

        // Let Admin access everything OR non-Admin, non-free plans, and unlocked reports
        if (props.user_type === 'Admin' || (props.user_type !== 'Admin' && planAccess && props.reports_unlocked)) {
            return (
                <a href={reportLink} onMouseEnter={() => handleReportMouseLeave('leave')}>{reportName}</a>
            )
        }
    }

    const resultsTable = (firmResults = true) => {
        let sResults = firmResults ? searchResults.results : searchResults.admin_results

        return (
            <table className='results-table'>
                <thead>
                    <tr>
                        <td>Client ID</td>
                        <td>Client Name</td>
                        <td>Map File</td>
                        <td>NAICS</td>
                        <td>Partner</td>
                        <td>Office</td>
                        <td>State</td>
                        <td>Status</td>
                    </tr>
                </thead>
                <tbody>
                    {sResults.map(r => {
                        let reportLink = firmResults ? hrefBuilder(r.subdomain, '/reports/analysis') : hrefBuilder(r.subdomain, '/companies')
                        let mapLink = r.parent_id ? hrefBuilder(r.subdomain, '/mapping_approvals/new') : null
                        return (
                            <tr>
                                <td>
                                    <a href={reportLink}>{r.name}</a>
                                </td>
                                <td>
                                    {r.real_name}
                                </td>
                                <td>
                                    {mapLink ? <a href={mapLink}><FontAwesomeIcon icon={faMap} /></a> : null}
                                </td>
                                <td>
                                    {r.naics_code}
                                </td>
                                <td>
                                    {r.partners}
                                </td>
                                <td>
                                    {r.office}
                                </td>
                                <td>
                                    {r.state}
                                </td>
                                <td>
                                    {r.status}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )
    }

    const closeNewUserModal = () => {
        setNewUserModalOpen(false)
    }
    // {reportLinkBuilder('People', props.plan_type_access.people)}
    // {reportLinkBuilder('Customers', props.plan_type_access.customers)}

    return (
        <>
            {props.isAdminView
                ? null
                : (
                    <VideoModal
                        isOpen={videoModalOpen}
                        onRequestClose={closeVideoModal}
                        modalReport={modalReport}
                        planAccess={props.plan_type_access}
                        parentSubdomain={props.parent_subdomain}
                        unlockReportsURL={props.unlock_reports_url}
                        reportCredits={props.report_credit}
                        userType={props.user_type}
                        reportsUnlocked={props.reports_unlocked}
                    />
                )
            }
            <Modal
                className={{
                    base: 'client-modal-content',
                    afterOpen: 'client-modal-content_after-open',
                    beforeClose: 'client-modal-content_before-close',
                }}
                overlayClassName={{
                    base: 'overlay-base',
                    afterOpen: 'overlay-base_after-open',
                    beforeClose: 'overlay-base_before-close',
                }}
                isOpen={newUserModalOpen}
                onRequestClose={closeNewUserModal}
                shouldCloseOnOverlayClick={true}
                closeTimeoutMS={0}
                contentLabel='New User Create Form Modal'
            >
                <header className='company-modal-header'>
                    <button
                        type='button'
                        className='btn btn-dark modal-close-btn'
                        onClick={closeNewUserModal}
                    >
                        <i className='fa fa-times'></i>
                    </button>
                    <h1 className='client-company-name'>New User</h1>
                </header>
                <NewUserForm using_navbar={true} email_ends={newUserFormData.email_ends} filter_options_obj={newUserFormData.filter_options_obj} all_companies={newUserFormData.all_companies} />
            </Modal>
            <div className='top-navbar-container'>
                <div className='peerview-logo-container'>
                    <a className='peerview-logo-link' href={userDashboardLink}>
                        <img className='peerview-logo-circle' src={peerviewLogoCircle} alt="Peerview Data Logo" />
                    </a>
                    {!props.single_company_client_user
                        ? (
                            <div className='search-bar-container'>
                                <div className='search-bar-div'>
                                    <FontAwesomeIcon className='search-icon' icon={faMagnifyingGlass} />
                                    <input
                                        className='nav-search-bar'
                                        type="text"
                                        placeholder="Search Peerview Data"
                                        value={searchQuery}
                                        onClick={() => openSearchResults()}
                                        onChange={(e) => handleInputChange(e)}
                                    />
                                </div>
                                <div className='nav-add-new-container'>
                                    {props.isAdminView ? null : <button className='nav-add-new-btn' onClick={() => setAddNew(!addNew)}>+</button>}
                                    {
                                        addNew && (<div className='nav-add-new-div'>
                                            <ul>
                                                <li onClick={() => handleNewUserFormData()}>
                                                    <a>New User</a>
                                                </li>
                                                <li>
                                                    <a href={newCompanyLink}>New Client</a>
                                                </li>
                                            </ul>
                                        </div>)
                                    }
                                </div>
                            </div>
                        )
                        : null
                    }
                </div>
                {props.isAdminView
                    ? <div>Super Admin Portal</div>
                    : <div className='navbar-client-name'>{props.company_type === 'client' && props.company_real_name ? `Viewing Client: ${props.company_name}, ${props.company_real_name}` : props.company_type === 'client' ? `Viewing Client: ${props.company_name}` : ''}</div>
                }
                <nav className='right-side-links'>
                    <ul className='right-icons'>
                        {!props.isAdminView && !props.single_company_client_user
                            ?
                            (<li>
                                <a className='right-link' href={manageFirmLink}>
                                    <FontAwesomeIcon icon={faGear} />
                                </a>

                            </li>)
                            : null
                        }
                        {!props.isAdminView && !props.single_company_client_user
                            ?
                            (<li>
                                <a className='right-link' href={notificationLink}>
                                    <FontAwesomeIcon icon={faBell} />
                                </a>
                            </li>)
                            : null
                        }
                    </ul>
                    <div className='vertical-divider'></div>
                    <div className='user-menu-btn'
                        ref={buttonRef}
                        onClick={() => setDisplayUserMenu(!displayUserMenu)}
                    >
                        <span>{props.isAdminView ? props.user_name : props.parent_company_name}</span> <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                    {
                        displayUserMenu && (
                            <div className='user-menu-container' ref={modalRef}>
                                <div className='user-info-and-links'>
                                    <span className='user-name'>{props.user_name}</span>
                                    <a href={profileLink}>Edit Your Profile</a>
                                </div>
                                <ul className='user-menu-links'>
                                    {props.user_type === 'Admin'
                                        ? (<li>
                                            <a href={exportsLink}>Exports</a>
                                        </li>)
                                        : null}
                                    {!props.isAdminView && !props.single_company_client_user
                                        ? (<li>
                                            <a href={manageFirmLink}>Manage Firm</a>
                                        </li>)
                                        : null}
                                    {!props.isAdminView && !props.single_company_client_user
                                        ? (<li>
                                            <a href={manageSubscriptionsLink}>Manage Subscription</a>
                                        </li>) : null}
                                    {!props.isAdminView && !props.single_company_client_user
                                        ? (<li>
                                            Plan: {props.plan_type}
                                        </li>) : null}
                                    {!props.isAdminView && !props.single_company_client_user
                                        ? (<li>
                                            <a href={notificationLink}>Notifications</a>
                                        </li>)
                                        : null}
                                    {props.isAdminView
                                        ? (<li>
                                            <a href={controlPanelLink}>Control Panel</a>
                                        </li>)
                                        : null}
                                    {props.true_user && (<li className='sign-out-link'>
                                        <form id="stop-impersonation-form" action="/impersonate" method="POST">
                                            <input type="hidden" name="_method" value="delete" />
                                            <input type='hidden' name='authenticity_token' value={window.token} />
                                            <button className='sign-out-btn' type="submit">Stop Impersonate</button>
                                        </form>
                                    </li>)}
                                    <li className='sign-out-link'>
                                        <form action={signOutLink} method="POST">
                                            <input type="hidden" name="_method" value="delete" />
                                            <button className='sign-out-btn' type="submit">Sign Out</button>
                                        </form>
                                    </li>
                                </ul>
                            </div>
                        )
                    }
                </nav>
                {
                    searchResults.display && (<div className='search-results-container'>
                        <div className='close-search-btn'><button onClick={() => closeSearchResults()}>X</button></div>
                        <div className='search-results-div'>
                            <span className='search-title'>Search Your Clients</span>
                            <div className='results-table-container'>
                                {props.user_type === 'Admin' && searchResults.admin_results.length > 0
                                    ? <div className='admin-results-container'>
                                        <span className='search-title'>Admin Results</span>
                                        {resultsTable(false)}
                                    </div>
                                    : null
                                }
                                {
                                    searchResults.results.length > 0
                                        ?
                                        <div>
                                            <span className='search-title'>Results</span>
                                            {resultsTable(true)}
                                        </div>
                                        : null
                                }
                            </div>
                        </div>
                    </div>)
                }
            </div>
            <div className={`left-navbar-container ${expandNavbar ? 'expanded' : 'collapsed'}`}>
                <nav>
                    <ul>
                        {!props.isAdminView && props.company_type === 'client' && <li className='left-menu-item'>
                            <div
                                key='report-links'
                                className='left-menu-div'
                                onMouseEnter={() => handleMouseEnter('reports')}
                                onMouseLeave={() => handleMouseLeave(null)}
                            >
                                <FontAwesomeIcon icon={faFileLines} className='menu-icon' />
                                <span className='left-menu-text'>Reports</span>
                                {analysisReportViewPopover === 'analysisreportviews' && (reportViewLinksAdminAnalysis.length > 0 || reportViewLinksNormalAnalysis.length > 0) && (
                                    <div
                                        key='money-report-view-links'
                                        className={expandNavbar ? "reportviews-nav-popover-expanded" : "reportviews-nav-popover"}
                                        onMouseEnter={() => handleAnalysisReportMouseEnter('analysisreportviews')}
                                        onMouseLeave={() => handleReportMouseLeave('leave')}
                                    >
                                        {
                                            reportViewLinksAdminAnalysis.map(reportView => {
                                                let archiveText = reportView.archived ? '(Archived)' : ''
                                                return <a key={`${reportView.id}-report-view`} href={reportView.link}>{`${reportView.name} ${archiveText}`}</a>
                                            })
                                        }
                                        {
                                            reportViewLinksNormalAnalysis.map(reportView => {
                                                let archiveText = reportView.archived ? '(Archived)' : ''
                                                return <a key={`${reportView.id}-report-view`} href={reportView.link}>{`${reportView.name} ${archiveText}`}</a>
                                            })
                                        }
                                    </div>
                                )}
                                 {moneyReportViewPopover === 'moneyreportviews' && (reportViewLinksAdminMoney.length > 0 || reportViewLinksNormalMoney.length > 0) && (
                                    <div
                                        key='money-report-view-links'
                                        className={expandNavbar ? "reportviews-nav-popover-expanded" : "reportviews-nav-popover"}
                                        onMouseEnter={() => handleAnalysisReportMouseEnter('moneyreportviews')}
                                        onMouseLeave={() => handleReportMouseLeave('leave')}
                                    >
                                        {
                                            reportViewLinksAdminMoney.map(reportView => {
                                                let archiveText = reportView.archived ? '(Archived)' : ''
                                                return <a key={`${reportView.id}-report-view`} href={reportView.link}>{`${reportView.name} ${archiveText}`}</a>
                                            })
                                        }
                                        {
                                            reportViewLinksNormalMoney.map(reportView => {
                                                let archiveText = reportView.archived ? '(Archived)' : ''
                                                return <a key={`${reportView.id}-report-view`} href={reportView.link}>{`${reportView.name} ${archiveText}`}</a>
                                            })
                                        }
                                    </div>
                                )}
                                {activePopover === 'reports' && (
                                    <div
                                        key='money-report-and-monthly-forecast-links'
                                        className={expandNavbar ? "reports-left-nav-popover-expanded" : "reports-left-nav-popover"}
                                        onMouseEnter={() => handleMouseEnter('reports')}
                                        onMouseLeave={() => handleMouseLeave('leave', 'reports')}
                                    >
                                        <span className='popover-title'>{props.company_real_name ? `Client: ${props.company_name}, ${props.company_real_name}` : `Client: ${props.company_name}`}</span>
                                        <a
                                            href={analysisLink}
                                            onMouseEnter={() => handleAnalysisReportMouseEnter('analysisreportviews')}
                                            onMouseLeave={() => handleReportMouseLeave(null)}
                                        >Analysis</a>
                                        {reportLinkBuilder('Planning', props.plan_type_access.forecast)}
                                        <a
                                            href={reportingLink}
                                            onMouseEnter={() => handleMoneyReportMouseEnter('moneyreportviews')}
                                            onMouseLeave={() => handleReportMouseLeave(null)}
                                        >Reporting</a>
                                        {!props.single_company_client_user ? <a href={mappingLink} style={{ 'borderTop': '1px solid #908f8f' }} onMouseEnter={() => handleReportMouseLeave('leave')}>Map File</a> : null}
                                        {props.parent_subdomain === 'cainellsworth' ? <a href={iowaLink} style={{ 'borderTop': '1px solid #908f8f' }} onMouseEnter={() => handleReportMouseLeave('leave')}>Iowa Report</a> : null}
                                        {props.parent_subdomain === 'cainellsworth' ? <a href={manhatLink} onMouseEnter={() => handleReportMouseLeave('leave')}>Manhattan Report</a> : null}
                                        {props.parent_subdomain === 'cainellsworth' ? <a href={minnesotaLink} onMouseEnter={() => handleReportMouseLeave('leave')}>Minnesota Report</a> : null}
                                    </div>
                                )}
                            </div>
                        </li>}
                        {props.isAdminView
                            ? (<li key='super-admin-links' className='left-menu-item'>
                                <div
                                    className='left-menu-div'
                                    onMouseEnter={() => handleMouseEnter('admin-links')}
                                    onMouseLeave={() => handleMouseLeave(null)}
                                >
                                    <FontAwesomeIcon icon={faShield} className='menu-icon' />
                                    <span className='left-menu-text'>Admin Links</span>
                                    {activePopover === 'admin-links' && (
                                        <div className={expandNavbar ? "left-nav-popover-expanded" : "left-nav-popover"}
                                            onMouseEnter={() => handleMouseEnter('admin-links')}
                                            onMouseLeave={() => handleMouseLeave('leave')}
                                        >
                                            {props.user_type === 'Admin' ? <a href={superAdminLink}>Super Admin Portal</a> : null}
                                            <a href={superCompaniesLink} style={{ 'borderTop': '1px solid #908f8f' }}>All Companies</a>
                                            <a href={superParentCompaniesLink}>Parent Companies</a>
                                            <a href={superNaicsLink}>NAICS</a>
                                            <a href={superOpsLink}>Ops View</a>
                                            <a href={superDashBoardEditorLink}>Admin Reports Editor</a>
                                        </div>
                                    )}
                                </div>
                            </li>)
                            : null
                        }
                        {!props.isAdminView && !props.single_company_client_user
                            ?
                            (<li key='admin-portals' className='left-menu-item'>
                                <div
                                    className='left-menu-div'
                                    onMouseEnter={() => handleMouseEnter('admin-portals')}
                                    onMouseLeave={() => handleMouseLeave(null)}
                                >
                                    <FontAwesomeIcon icon={faShield} className='menu-icon' />
                                    <span className='left-menu-text'>Admin Portals</span>
                                    {activePopover === 'admin-portals' && (
                                        <div className={expandNavbar ? "left-nav-popover-expanded" : "left-nav-popover"}
                                            onMouseEnter={() => handleMouseEnter('admin-portals')}
                                            onMouseLeave={() => handleMouseLeave('leave')}
                                        >
                                            {props.user_type === 'Admin' ? <a href={superAdminLink}>Super Admin Portal</a> : null}
                                            <a href={parentAdminLink} style={props.user_type === 'Admin' ? { 'borderTop': '1px solid #908f8f' } : null}>{props.parent_company_name} Admin Portal</a>
                                            {props.company_type === 'client' && <a href={childAdminLink}>{props.company_name} Admin Portal</a>}
                                        </div>
                                    )}
                                </div>
                            </li>)
                            : null}
                        {!props.single_company_client_user ? <hr className='left-nav-divider' /> : null}
                        {
                            !props.isAdminView
                                ? <>
                                    {!props.single_company_client_user
                                        ? (<li key='manage-clients-link' className='left-menu-item'>
                                            <div
                                                className='left-menu-div'
                                                onMouseEnter={() => handleMouseEnter('Manage Clients')}
                                                onMouseLeave={() => handleMouseLeave(null)}
                                            >
                                                <a href={manageClientsLink}><FontAwesomeIcon icon={faUser} className='menu-icon' />
                                                    <span className='left-menu-text'>Manage Clients</span></a>
                                                {activePopover === 'Manage Clients' && !expandNavbar && (
                                                    <div 
                                                        className='single-link-no-expand'
                                                        onMouseEnter={() => handleMouseEnter('Manage Clients')}
                                                        onMouseLeave={() => handleMouseLeave('leave')}
                                                    >
                                                        <a href={manageClientsLink}><span>Manage Clients</span></a>
                                                    </div>
                                                )}
                                            </div>
                                        </li>)
                                        : null}
                                    {!props.single_company_client_user
                                        ? (<li key='firm-link' className='left-menu-item'>
                                            <div
                                                className='left-menu-div'
                                                onMouseEnter={() => handleMouseEnter('Firm')}
                                                onMouseLeave={() => handleMouseLeave(null)}
                                            >
                                                {reportLinkBuilder('Firm', props.plan_type_access.firm)}
                                                {activePopover === 'Firm' && !expandNavbar && (
                                                    <div 
                                                        className='single-link-no-expand'
                                                        onMouseEnter={() => handleMouseEnter('Firm')}
                                                        onMouseLeave={() => handleMouseLeave('leave')}
                                                    >
                                                        {reportLinkBuilder('Firm', props.plan_type_access.firm, false)}
                                                    </div>
                                                )}
                                            </div>
                                        </li>)
                                        : null}
                                    {!props.single_company_client_user
                                        ? (<li key='practice-link' className='left-menu-item'>
                                            <div
                                                className='left-menu-div'
                                                onMouseEnter={() => handleMouseEnter('Practice')}
                                                onMouseLeave={() => handleMouseLeave(null)}
                                            >
                                                {reportLinkBuilder('Practice', props.plan_type_access.practice)}
                                                {activePopover === 'Practice' && !expandNavbar && (
                                                    <div 
                                                        className='single-link-no-expand'
                                                        onMouseEnter={() => handleMouseEnter('Practice')}
                                                        onMouseLeave={() => handleMouseLeave('leave')}
                                                    >
                                                        {reportLinkBuilder('Practice', props.plan_type_access.practice, false)}
                                                    </div>
                                                )}
                                            </div>
                                        </li>)
                                        : null}
                                    {!props.single_company_client_user
                                        ? (
                                            <li key='industry-link' className='left-menu-item'>
                                                <div
                                                    className='left-menu-div'
                                                    onMouseEnter={() => handleMouseEnter('Industry')}
                                                    onMouseLeave={() => handleMouseLeave(null)}
                                                >
                                                    {reportLinkBuilder('Industry', props.plan_type_access.industry)}
                                                    {activePopover === 'Industry' && !expandNavbar && (
                                                        <div 
                                                            className='single-link-no-expand'
                                                            onMouseEnter={() => handleMouseEnter('Industry')}
                                                            onMouseLeave={() => handleMouseLeave('leave')}
                                                        >
                                                            {reportLinkBuilder('Industry', props.plan_type_access.industry, false)}
                                                        </div>
                                                    )}
                                                </div>
                                            </li>
                                        )
                                        : null}
                                </>
                                : null
                        }
                        <li key='resouces-link' className='left-menu-item'>
                            <div
                                className='left-menu-div'
                                onMouseEnter={() => handleMouseEnter('Resources')}
                                onMouseLeave={() => handleMouseLeave(null)}
                            >
                                <a href={resourcesLink} target='_blank'><FontAwesomeIcon icon={faBook} className='menu-icon'/>
                                    <span className='left-menu-text'>Resources</span></a>
                                {activePopover === 'Resources' && !expandNavbar && (
                                    <div 
                                        className='single-link-no-expand'
                                        onMouseEnter={() => handleMouseEnter('Resources')}
                                        onMouseLeave={() => handleMouseLeave('leave')}
                                    >
                                       <a href={resourcesLink} target='_blank'><span>Resources</span></a>
                                    </div>
                                )}
                            </div>
                        </li>
                        {!props.isAdminView && <li key='workflows-link' className='left-menu-item'>
                            <div
                                className='left-menu-div'
                                onMouseEnter={() => handleMouseEnter('Workflows')}
                                onMouseLeave={() => handleMouseLeave(null)}
                            >
                                <FontAwesomeIcon icon={faDiagramProject} className='menu-icon' />
                                <span className='left-menu-text'>Workflows</span>
                                {activePopover === 'Workflows' && (
                                    <div className={expandNavbar ? "workflow-popover-expanded" : "workflow-popover"}
                                        onMouseEnter={() => handleMouseEnter('Workflows')}
                                        onMouseLeave={() => handleMouseLeave('leave')}
                                    >
                                        <span className='popover-title'>Workflows</span>
                                        {
                                            workFlowSections.map(s => {
                                                return (
                                                    <>
                                                        <div className='workflow-section-title'>{s.title}</div>
                                                        <ul className='workflow-link-lists'>
                                                            {
                                                                s.linkIds.map(id => {
                                                                    let link = hrefBuilder(props.parent_subdomain, `/workflows/${id}`)
                                                                    let workFlow = workflows.find(w => w.id === id)
                                                                    return <li key={`${s.title}-${id}`}><a className='workflow-link' href={link} target='_blank'>{workFlow.title}</a></li>
                                                                })
                                                            }
                                                        </ul>
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                )}
                            </div>
                        </li>}
                        {(props.user_type === 'Admin' || props.nschbc_access) && <li key='nschbc-reports-link' className='left-menu-item'>
                            <div
                                className='left-menu-div'
                                onMouseEnter={() => handleMouseEnter('NSCHBC Reports')}
                                onMouseLeave={() => handleMouseLeave(null)}
                            >
                                <a href={nschbcLink}><FontAwesomeIcon icon={faHospital} className='menu-icon'/>
                                    <span className='left-menu-text'>NSCHBC Reports</span></a>
                                {activePopover === 'NSCHBC Reports' && !expandNavbar && (
                                    <div 
                                        className='single-link-no-expand'
                                        onMouseEnter={() => handleMouseEnter('NSCHBC Reports')}
                                        onMouseLeave={() => handleMouseLeave('leave')}
                                    >
                                       <a href={nschbcLink}><span>NSCHBC Reports</span></a>
                                    </div>
                                )}
                            </div>
                        </li>}
                        <li key='expand-collapse-btn' className='left-menu-item'>
                            <div className={expandNavbar ? 'left-menu-div-expand' : 'left-menu-div-collapse'}>
                                <FontAwesomeIcon icon={expandNavbar ? faCircleArrowLeft : faCircleArrowRight} onClick={() => toggleNavbar()} className='menu-icon' />
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
        </>
    )
}

export default TopNavbar